
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.686 7.643c-.6 0-.926-.777-.476-1.26l3.302-3.642a.648.648 0 01.5-.241.6.6 0 01.476.241l3.302 3.643c.45.482.125 1.259-.476 1.259H4.686zm6.628 1.714c.6 0 .926.804.476 1.286l-3.302 3.643a.573.573 0 01-.475.214c-.2 0-.376-.054-.5-.214L4.21 10.643c-.45-.482-.125-1.286.476-1.286h6.628z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      